module.exports = __webpack_public_path__ + "img/hand-paper.79b0cec9.svg";